import React from "react";
import { Accordion, Button, Card, Col, Form, Row } from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";

import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";
import SecurityLevel from "../../../../helpers/SecurityLevel";

import "./UpdateExaminationDialog.css";
import BaseDatePicker from "../../../../components/baseDatePicker/BaseDatePicker";

class UpdateExaminationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.securityOptions = SecurityLevel.getSecurityLevels(this.props.examination.instanceTemplate.type);

    this.autoOptions = [
      { value: false, label: "SingleExamination.UpdateExamModal.Form.Disable" },
      { value: true, label: "SingleExamination.UpdateExamModal.Form.Enable" }
    ];
    this.validationDefinition = {
      name: {
        defaultValue: this.props.examination.name,
        initValid: true,
        rule: ValidationHelper.isExaminationName
      },
      start: {
        defaultValue: new Date(Date.parse(this.props.examination.start)),
        initValid: true,
        rule: value =>
          ValidationHelper.isStartDate(value, this.state.validation.end.value)
      },
      end: {
        defaultValue: new Date(Date.parse(this.props.examination.end)),
        initValid: true,
        rule: value =>
          ValidationHelper.isEndDate(value, this.state.validation.start.value)
      },
      securityLevel: {
        defaultValue: this.props.examination.securityLevel,
        initValid: true,
        rule: ValidationHelper.isSecurityLevel
      },
      isAutoStart: {
        defaultValue: this.props.examination.isAutoStart,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      isAutoEnd: {
        defaultValue: this.props.examination.isAutoEnd,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      instructions: {
        defaultValue: Object.assign({}, this.props.examination.instructions),
        initValid: true,
        rule: ValidationHelper.isExtendedDescription
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(
        this.validationDefinition,
        true
      )
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
  }

  translateOptions(t, options) {
    if (Array.isArray(options)) {
      return options.map(o => ({ value: o.value, label: t(o.label) }));
    } else {
      return { value: options.value, label: t(options.label) };
    }
  }

  isDisabled(){
    return this.props.examination.status === 1 ||
        (this.props.examination.status >= 51 &&
            this.props.examination.status <= 53);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation({
          name: {
            defaultValue: this.props.examination.name,
            initValid: true,
            rule: ValidationHelper.isExaminationName
          },
          start: {
            defaultValue: new Date(Date.parse(this.props.examination.start)),
            initValid: true,
            rule: value =>
              ValidationHelper.isStartDate(
                value,
                this.state.validation.end.value
              )
          },
          end: {
            defaultValue: new Date(Date.parse(this.props.examination.end)),
            initValid: true,
            rule: value =>
              ValidationHelper.isEndDate(
                value,
                this.state.validation.start.value
              )
          },
          securityLevel: {
            defaultValue: this.props.examination.securityLevel,
            initValid: true,
            rule: ValidationHelper.isSecurityLevel
          },
          isAutoStart: {
            defaultValue: this.props.examination.isAutoStart,
            initValid: true,
            rule: ValidationHelper.isBoolean
          },
          isAutoEnd: {
            defaultValue: this.props.examination.isAutoEnd,
            initValid: true,
            rule: ValidationHelper.isBoolean
          },
          instructions: {
            defaultValue: this.props.examination.instructions,
            initValid: true,
            rule: ValidationHelper.isExtendedDescription
          }
        })
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    const now = Date.now();
    const instructions = Object.assign({}, this.props.examination.instructions);
    this.securityOptions = SecurityLevel.getSecurityLevels(this.props.examination.instanceTemplate.type);
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={(<div>
          <FontAwesomeIcon
            icon={faExclamationCircle}
            className={
              this.state.validation.name.isValid &&
              this.state.validation.securityLevel.isValid
                ? "display-none"
                : "mr-2 color-red"
            }
          />
          <span>
            {t("SingleExamination.UpdateExamModal.Form.ToggleBasic")}
          </span>
        </div>)}
        rightButtonText={t("SingleExamination.UpdateExamModal.Form.Submit")}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="0"
                >
                  <span>
                    {t("SingleExamination.UpdateExamModal.Form.ToggleBasic")}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formClassName">
                    <Form.Label>
                      {t("SingleExamination.UpdateExamModal.Form.ExamName")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={t(
                        "SingleExamination.UpdateExamModal.Form.ExamNamePlaceholder"
                      )}
                      disabled={this.isDisabled() && this.state.validation.start.value.getTime() <= now }
                      value={this.state.validation.name.value}
                      isInvalid={!this.state.validation.name.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleExamination.UpdateExamModal.ValidationError.Name"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectSecurity">
                    <Form.Label>
                      {t("SingleExamination.UpdateExamModal.Form.Security")}
                    </Form.Label>
                    <BaseSelect
                      options={this.translateOptions(t, this.securityOptions)}
                      onChange={s =>
                        this.handleChange({
                          target: {
                            name: "securityLevel",
                            value: s.value
                          }
                        })
                      }
                      isDisabled={this.isDisabled() && this.state.validation.start.value.getTime() <= now }
                      value={this.translateOptions(
                        t,
                        this.securityOptions.filter(
                          s =>
                            s.value === this.state.validation.securityLevel.value
                        )[0]
                      )}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.securityLevel.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "SingleExamination.UpdateExamModal.ValidationError.SecurityLevel"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Row>
                    <Col>
                      <Form.Group controlId="formDateStart">
                        <Form.Label>
                          {t(
                            "SingleExamination.UpdateExamModal.Form.StartTime"
                          )}
                        </Form.Label>
                        <div>
                          <BaseDatePicker
                              name="start"
                              className="form-control"
                              onChange={d => {
                                this.handleChange({ target: { name: "start", value: d }});
                                this.handleChange({ target: { name: "end", value: this.state.validation.end.value }});
                              }}
                              value={this.state.validation.start.value}
                              min={new Date()}
                              disabled={this.isDisabled()}
                          />
                        </div>
                        <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.start.isValid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t(
                            "SingleExamination.UpdateExamModal.ValidationError.Start"
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group controlId="formSelectAutoStart">
                        <Form.Label>
                          {t(
                            "SingleExamination.UpdateExamModal.Form.AutoStart"
                          )}
                        </Form.Label>
                        <BaseSelect
                          options={this.translateOptions(t, this.autoOptions)}
                          onChange={s =>
                            this.handleChange({
                              target: {
                                name: "isAutoStart",
                                value: s.value
                              }
                            })
                          }
                          isDisabled={this.isDisabled() && this.state.validation.start.value.getTime() <= now }
                          value={this.translateOptions(
                            t,
                            this.autoOptions.filter(
                              s =>
                                s.value ===
                                this.state.validation.isAutoStart.value
                            )[0]
                          )}
                        />
                        <Form.Control
                          type="hidden"
                          isInvalid={
                            !this.state.validation.isAutoStart.isValid
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {t(
                            "SingleExamination.UpdateExamModal.ValidationError.IsAutoStart"
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="formDateEnd">
                        <Form.Label>
                          {t(
                            "SingleExamination.UpdateExamModal.Form.EndTime"
                          )}
                        </Form.Label>
                        <div>
                          <BaseDatePicker
                              name="end"
                              className="form-control"
                              onChange={d => {
                                this.handleChange({ target: { name: "end", value: d } });
                                this.handleChange({ target: { name: "start", value: this.state.validation.start.value }});
                              }}
                              value={this.state.validation.end.value}
                              min={new Date()}
                              disabled={this.isDisabled()}
                          />
                        </div>
                        <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.end.isValid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t(
                            "SingleExamination.UpdateExamModal.ValidationError.End"
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group controlId="formSelectAutoStart">
                        <Form.Label>
                          {t(
                            "SingleExamination.UpdateExamModal.Form.AutoEnd"
                          )}
                        </Form.Label>
                        <BaseSelect
                          options={this.translateOptions(t, this.autoOptions)}
                          onChange={s =>
                            this.handleChange({
                              target: {
                                name: "isAutoEnd",
                                value: s.value
                              }
                            })
                          }
                          isDisabled={this.isDisabled() && this.state.validation.start.value.getTime() <= now }
                          value={this.translateOptions(
                            t,
                            this.autoOptions.filter(
                              s =>
                                s.value ===
                                this.state.validation.isAutoEnd.value
                            )[0]
                          )}
                        />
                        <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.isAutoEnd.isValid}
                        />
                        <Form.Control.Feedback type="invalid">
                          {t(
                            "SingleExamination.UpdateExamModal.ValidationError.IsAutoEnd"
                          )}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {this.isDisabled() && this.state.validation.start.value.getTime() < now ? "" : (
                <Card>
                  <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                    <Accordion.Toggle
                        as={Button}
                        variant="link"
                        className="acc-link"
                        eventKey="1"
                    >
                      <FontAwesomeIcon
                          icon={faExclamationCircle}
                          className={
                            this.state.validation.instructions.isValid
                                ? "display-none"
                                : "mr-2 color-red"
                          }
                      />
                      <span>
                    {t("SingleExamination.UpdateExamModal.Form.Instructions")}
                  </span>
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <MarkDownEditor
                          defaultValue={instructions}
                          disabled={this.isDisabled() && this.state.validation.start.value.getTime() <= now }
                          onChange={value =>
                              this.handleChange({
                                target: {
                                  name: "instructions",
                                  value: value
                                }
                              })
                          }
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
            )}
          </Accordion>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(UpdateExaminationDialog);
